import PipelineInstance from '@/components/pipelineInstance/pipelineInstance';

const PipelineBuilderPage = () => {
  return <PipelineInstance />;
};

export default PipelineBuilderPage;
